import { PayloadAction } from '@reduxjs/toolkit';

import { ECommerceProduct, VariantsState } from 'editor/src/store/variants/types';

const setECommerceProductReducer = (state: VariantsState, action: PayloadAction<ECommerceProduct>) => {
  state.eCommerceProduct = action.payload;
};

export default setECommerceProductReducer;
